const config = {
  application: {
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT ?? 'DEV',
    basePath: process.env.NEXT_PUBLIC_BASE_PATH ?? '',
    assetPrefix: process.env.NEXT_PUBLIC_ASSET_PREFIX ?? '',
  },
  telemetry: {
    apiKey: process.env.NEXT_PUBLIC_TELEMETRY_API_KEY ?? '',
  },
}

export default config
